import { array } from 'prop-types';
import React, { Fragment } from 'react';
import { translate } from '../Services/translation';

const QuickSearchResult = ({
  products,
  pages,
  result,
  selectedItem,
  searchUrl,
}) => {
  return (
    <div className="quick-search-result">
      <div className="row">
        <ul className="quick-search-result--products-wrapper columns small-12 medium-9">
          {products.length > 0 ? (
            <div className="quick-search-result__group-header">
              {translate('quicksearch.products')}
            </div>
          ) : (
            <div className="quick-search-result__group-header">
              {translate('quicksearch.no-products-matched-your-search')}
            </div>
          )}
          {products &&
            products.slice(0, 9).map((item, index) => (
              <Fragment key={`${item.name}-${index}`}>
                <li
                  key={item.url}
                  className={`quick-search-result__item ${
                    selectedItem === index
                      ? 'quick-search-result__item--selected'
                      : ''
                  }`}
                >
                  <a
                    className={
                      item.showAll
                        ? 'quick-search-result__show-all'
                        : `quick-search-result__link ${
                            item.url
                              ? ''
                              : 'quick-search-result__link--disabled'
                          }`
                    }
                    href={
                      item.showAll ? searchUrl + '&notinstock=true' : item.url
                    }
                  >
                    {item.hasImage && item.imageSource && (
                      <div className="quick-search-result__image--wrapper">
                        <img
                          className="quick-search-result__image"
                          src={item.imageSource}
                        />
                      </div>
                    )}
                    <div className="quick-search-result__item--title">
                      {item.name} {item.productSize}
                      <span>{item.brand}</span>
                    </div>
                  </a>
                </li>
              </Fragment>
            ))}
        </ul>
        <ul className="columns small-12 medium-3 quick-search-result--links-wrapper">
          {pages.length > 0 ? (
            <li className="quick-search-result__item quick-search-result__group-header">
              {translate('quicksearch.pages')}
            </li>
          ) : (
            ''
          )}
          {pages &&
            pages.slice(0, 8).map((item) => (
              <li key={`${item.name}-${item.url}`}>
                <a href={item.url}>{item.name}</a>
              </li>
            ))}
        </ul>
      </div>
      {(pages.length > 0 || products.length > 0) && (
        <div className="quick-search-result__submit-row columns">
          <a
            className="quick-search-result__submit-row--button button button--secondary"
            href={searchUrl}
          >
            {translate('quicksearch.show-all')}
          </a>
        </div>
      )}
    </div>
  );
};

export default QuickSearchResult;
